import Vue from 'vue'
import Vuex from 'vuex'
import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import axios from "axios";
import {latLng} from "leaflet";

Vue.use(Vuex)

@Module
class Data extends VuexModule {

    legendHidden = true;

    refreshingData = false;

    centreData = {};
    fetchedcentreData = false;

    @Action({commit: 'centreDataFetched'})
    async fetch_data() {
        const result = await axios.get(`/api/centres/`);
        return result.data;
    }

    @Mutation
    centreDataFetched(data: any) {
        this.centreData = data.reduce((obj: any, v: any) => {
            v.latLng = latLng(v.location_lat, v.location_long)
            if (v.total_availability === 0) {
                v.icon = 'red'
            } else if (v.total_availability < .10) {
                v.icon = 'orange'
            } else if (v.total_availability < .35) {
                v.icon = 'yellow'
            } else {
                v.icon = 'green'
            }
            obj[v.id] = v
            return obj
        }, {});
        this.fetchedcentreData = true;
        this.refreshingData = false;
    }

    datesData = {}
    datesHeaders = {}
    centreHours = {}
    centreDates = {}
    lastUpdate = {}



    @Action({commit: 'datesDataFetched'})
    async fetchDates(payload: { centre: number }) {
        const result = await axios.get(`/api/centres/${payload.centre}/`);
        return result.data;
    }

    @Mutation
    datesDataFetched(data: any) {
        Vue.set((this.lastUpdate as any), data.id, data.last_updated)
        const hours = data.all_hours.sort().reduce((obj: any, v: string) => {
            obj[v] = `item.${v}`
            return obj
        }, {})
        Vue.set((this.centreHours as any), data.id, hours)
        const headers = data.dates.map((x: any) => {
            return {
                text: x.date,
                align: 'end',
                sortable: false,
                value: x.date,
            }
        })
        // const headers = data.all_hours.sort().map((x: string) => {
        //     return {
        //         text: x,
        //         align: 'start',
        //         sortable: false,
        //         value: x,
        //     }
        // })
        headers.unshift({
            text: "Hour",
            align: 'end',
            sortable: false,
            value: "hour",

        })
        Vue.set((this.datesHeaders as any), data.id, headers)

        const dates = data.dates.reduce((obj: any, v: any) => {
            obj[v.date] = `item.${v.date}`
            return obj
        }, {})
        Vue.set((this.centreDates as any), data.id, dates)
        // console.log(hours)
        const tableData = Object.keys(hours).map((hour: string) => {
            const hourData = data.dates.reduce((obj: any, v: any) => {
                // console.log(obj.per_hour, hour)
                // console.log(obj)
                const perHour = v.per_hour.filter((h: any) => {
                    // console.log(h, hour)
                    return h.hour === hour
                }).pop()
                if (perHour) {
                    obj[v.date] = Number(1 - ((perHour.fill - 1) / 4))
                }
                return obj

            }, {})
            hourData.hour = hour
            return hourData
        })
        // console.log(tableData)

        Vue.set((this.datesData as any), data.id, tableData)
    }


}


export default new Vuex.Store({
    modules: {
        data: Data
    }
})
